<template>
  <div class="p-4 rounded-xl shadow-md bg-white">
    <div class="flex items-center justify-between">
      <p class="text-sm font-medium text-gray-500">Performance de la veille</p>
      <span class="text-right text-xs font-medium px-2 py-1 rounded" :class="statusClass">
        {{ formatPercentage(progression) }}
      </span>
    </div>
    <p class="text-2xl text-black my-4">{{ $t("roadmap.contracts", current) }}</p>
    <span class="text-xs text-gray-600">{{ current }} / {{ target }} contrats vendus</span>
    <ProgressionBar :value="current" :max="target" />
  </div>
</template>

<script>
import { ProgressionBar } from "@estaly/ui";
import { formatPercentage } from "@estaly/ui/src/utils/percentage_formatter";

export default {
  components: {
    ProgressionBar,
  },
  props: {
    current: {
      type: Number,
      required: true,
    },
    target: {
      type: Number,
      required: true,
    },
  },
  computed: {
    progression() {
      return this.target > 0 ? this.current / this.target : 0;
    },
    statusClass() {
      if (this.progression < 0.8) return "bg-red-100 text-red-800";
      if (this.progression <= 1) return "bg-blue-100 text-blue-800";
      return "bg-green-100 text-green-800";
    },
  },
  methods: {
    formatPercentage,
  },
};
</script>
